import { render, staticRenderFns } from "./FeedbackDiagramComponent.vue?vue&type=template&id=6254fa52"
import script from "./FeedbackDiagramComponent.vue?vue&type=script&lang=ts"
export * from "./FeedbackDiagramComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports